
export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const fadeScrollOffset = $(window).height() * 0.25;

    function optacities() {
      $('.home-block').each(function() {
        let s = $(document).scrollTop()+fadeScrollOffset,
        h = $(this).height(),
        ft = $(this).offset().top

        let elStart = ft-(2*fadeScrollOffset);
        let elEnd = ft + h - fadeScrollOffset;

        if(s < elStart) $(this).find('.bg').css({opacity: 0 })

        if(s > elStart && s < ft){
          let p = s - elStart
          $(this).find('.bg').css({opacity: p/fadeScrollOffset })
        }

        if(s > ft && s < ft+h){
          $(this).find('.bg').css({opacity: 1 })
        }

        if(s < ft+h && s > elEnd){
          let p = s - elEnd
          let p2 = fadeScrollOffset - p;

          $(this).find('.bg').css({opacity: p2/fadeScrollOffset })
        }

        if(s > ft+h) $(this).find('.bg').css({opacity: 0 })


      })
    }

    optacities()

    document.querySelector('.move-down').addEventListener("click",function(){
      $('html, body').animate({
        scrollTop: $(".home-block").offset().top,
      }, 500)
    })
    $('.home-block').append("<div class='bg'></div>")
    $('.home-block .bg').css({ opacity: 0 })

    $( document ).on( 'scroll', optacities)
    $( window ).resize(optacities)
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/home.js